import { TCountry } from '../models/country.ts';
import { TCmsMedia } from '../models/flow.ts';
import { findDocs } from '../payload/client.ts';
import { MEDIA_POPULATE, resolveMediaUrl } from '../payload/media.ts';

const COLLECTION = 'country_flags';

const COUNTRY_LIMIT = 300;

type TPayloadCountryFlag = {
  name: string;
  country_code_iso: string;
  country_code?: { calling_code: string }[] | null;
  images?: TCmsMedia[] | null;
};

export const getCountries = async (): Promise<TCountry[]> => {
  const countries = await findDocs<TPayloadCountryFlag>(COLLECTION, {
    depth:    1,
    limit:    COUNTRY_LIMIT,
    sort:     'name',
    populate: MEDIA_POPULATE,
  });

  return countries.map((country) => ({
    name:           country.name,
    countryCodeIso: country.country_code_iso,
    callingCode:    country.country_code?.[0]?.calling_code ?? '',
    flag:           resolveMediaUrl(country.images?.[0]),
  }));
};
